import { z } from 'zod';
export const NonEmptyStringSchema = z.string().trim().min(1);
export const ProjectStatusSchema = z.enum(['draft', 'in_progress', 'completed', 'archived']);
export const QuestionTypeSchema = z.enum([
    'open',
    'rating',
    'multiple_choice',
    'single_choice',
    'free_text',
    'concept_test',
]);
/**
 * Stimulus media attached to a question (core-revision level, locale-neutral).
 * `url` is the public blob URL stored at attach time; `blobPath` is kept for
 * future re-resolution if the storage domain ever changes. `description` is
 * researcher-written and doubles as the moderator prompt note and alt text.
 */
export const QuestionMediaSchema = z
    .object({
    url: z.string().url(),
    blobPath: z.string().min(1).optional(),
    description: z.string().trim().min(1).max(500),
    contentType: z.string().optional(),
    byteSize: z.number().multipleOf(1).nonnegative().optional(),
    width: z.number().multipleOf(1).positive().optional(),
    height: z.number().multipleOf(1).positive().optional(),
})
    .strict();
export const VoiceSchema = z.enum([
    'alloy',
    'ash',
    'ballad',
    'coral',
    'echo',
    'sage',
    'shimmer',
    'verse',
]);
export const QuestionSchema = z
    .object({
    id: z.string(),
    type: QuestionTypeSchema,
    text: NonEmptyStringSchema,
    options: z.array(z.string()).optional(),
    required: z.boolean().optional(),
    followUpCount: z.number().multipleOf(1).nonnegative().optional(),
    followUpGuidance: z.string().optional(),
    media: QuestionMediaSchema.optional(),
})
    .passthrough();
export const FieldInitMetadataSchema = z
    .object({
    initializedAt: z.string().datetime(),
    initializedBy: z.enum(['ai', 'user']),
})
    .strict();
export const FieldInitializationStateSchema = z.record(z.string(), FieldInitMetadataSchema);
export const PageSchema = z
    .object({
    limit: z.number().multipleOf(1).nonnegative(),
    offset: z.number().multipleOf(1).nonnegative(),
    total: z.number().multipleOf(1).nonnegative(),
})
    .strict();
//# sourceMappingURL=common.js.map